
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm3.7 8.1l-4 4c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-2-2c-.3-.4-.3-1.1.2-1.4.4-.3.9-.3 1.2 0L11 13l3.3-3.3c.4-.4 1.1-.3 1.4.1.3.4.3 1 0 1.3z"}})])
          )
        }
      }
    